// src/app/core/http/auth.interceptor.ts
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../../auth/auth.service';

// Compile regex patterns once to avoid performance overhead
const MENTIONS_ROUTE_REGEX = /\/mentions\/(unread-count|mark-read)$/i;
const MESSAGE_ROUTE_REGEX = /\/actualite\/(messages|commentaires)\/[^/]+$/i;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth  = inject(AuthService);
  const token = auth.tokenSnapshot();

  // ⬇️ N'ajoute pas le header sur les routes d'auth
  const isAuthRoute = /\/api\/v1\/auth\/(login|register)$/i.test(req.url);

  // ⬇️ Clone avec Authorization seulement si utile
  const cloned = token && !isAuthRoute && !req.headers.has('Authorization')
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

  return next(cloned).pipe(
    catchError((err: HttpErrorResponse) => {
      // Exclure les endpoints mentions et messages des logouts automatiques
      const isMentionsRoute = MENTIONS_ROUTE_REGEX.test(req.url);
      const isMessageRoute = MESSAGE_ROUTE_REGEX.test(req.url);
      
      // Vérifier si c'est une erreur d'accès refusé (droits insuffisants) plutôt qu'une session invalide
      const isAccessDenied = err?.error?.error === 'access_denied';
      
      // 401/403/419/440 → session invalide → logout (sauf pour mentions, messages et access_denied)
      if ([401, 403, 419, 440].includes(err.status) && !(auth as any).isLoggingOut && 
          !isMentionsRoute && !isMessageRoute && !isAccessDenied) {
        auth.logout(true);
      }
      return throwError(() => err);
    })
  );
};
